/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看数字人民币订单是否支付成功
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class NumberPayStatusParams {
  constructor(public billNo?: string) {}
}

export default async function (
  params: NumberPayStatusParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/numberPayStatus`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
